import { useContext, useMemo } from "react"
import PropTypes from "prop-types"
import ListItemDropDown from "components/list-item-dropdown"
import { useAnalytics } from "connected-components/analytics"
import { useAssetViewHeaderHandlers } from "connected-components/asset-view/hooks/use-asset-view-header-handlers"
import { getFactorCategoryDropdownOptions } from "connected-components/asset-view/helpers/header-dropdown-options"
import { useSourceTemplateMetricIds } from "connected-components/asset-view/hooks/use-source-displayed-metrics"
import { RISK_CONTEXT } from "./context"
import { noop } from "lodash"

export default function RiskHeader({ modelMetadata, flattenedMetrics, onMetricsChange }) {
  const riskContext = useContext(RISK_CONTEXT)
  const { selectedCategory, setSelectedCategory } = riskContext

  const analytics = useAnalytics()
  const { handleCategoryChange } = useAssetViewHeaderHandlers({
    track: analytics.track,
    setSelectedCategory,
  })

  const metricOptions = useMemo(() => ({ prefix: "risk", selectedCategory }), [selectedCategory])

  useSourceTemplateMetricIds({ flattenedMetrics, onMetricsChange, metricOptions, includeSummaryRows: true })

  const options = useMemo(
    () => getFactorCategoryDropdownOptions(modelMetadata),
    [modelMetadata],
  )

  return <>
    <ListItemDropDown
      label="Display"
      setValue={noop}
      value="single"
      options={[{ id: "single", primaryText: "Risk Decomposition" }]}
      alignMenu="left"
    />
    <ListItemDropDown
      label="Factor view"
      value={selectedCategory}
      setValue={handleCategoryChange}
      options={options}
      alignMenu="left"
      disablePortal
    />
  </>
}

RiskHeader.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
  flattenedMetrics: PropTypes.object,
  onMetricsChange: PropTypes.func,
}
